'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReportService = function () {
  function ReportService($http) {
    'ngInject';

    _classCallCheck(this, ReportService);

    Object.assign(this, {
      $http: $http
    });
  }

  _createClass(ReportService, [{
    key: 'getReportTypes',
    value: function getReportTypes() {
      return [{
        name: 'Administrations by Category (Bar)',
        state: 'administrationsByCategoryBar',
        enabled: true
      }, {
        name: 'Administrations by Category (Area)',
        state: 'administrationsByCategoryArea',
        enabled: true
      }, {
        name: 'Administrations by Category (Pie)',
        state: 'administrationsByCategoryPie',
        enabled: true
      }, {
        name: 'Administrations Trend',
        state: 'administrationTrend',
        enabled: true
      }, {
        name: 'Ingredient Risk',
        state: 'ingredientRisk',
        enabled: true
      }, {
        name: 'Risk by Year',
        state: 'riskByYear',
        enabled: true
      }, {
        name: 'Serious Risk by Year',
        state: 'seriousRiskByYear',
        enabled: true
      }, {
        name: 'System Metrics',
        state: 'systemMetrics',
        enabled: true
      }];
    }
  }, {
    key: 'getYears',
    value: function getYears() {
      var date = new Date();
      var years = [];
      var currentYear = date.getFullYear();

      for (var i = currentYear; i > currentYear - 10; i -= 1) {
        years.push(i);
      }

      return years;
    }
  }]);

  return ReportService;
}();

exports.default = ReportService;


// WEBPACK FOOTER //
// ./services/report.service.js